import React from 'react';
import { TSR_OFFICE_ADDRESS } from '../content/siteAddress';
import { DEFAULT_OG_IMAGE, SITE_URL } from './seoConfig';

const businessSchema = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'FoodEstablishment', 'CateringService'],
  name: 'TSR Catering',
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  telephone: '+91 7249464781',
  email: 'alpphafoods@gmail.com',
  address: {
    '@type': 'PostalAddress',
    ...TSR_OFFICE_ADDRESS.schema,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 18.559,
    longitude: 73.7868,
  },
  areaServed: [
    { '@type': 'City', name: 'Pune' },
    { '@type': 'Place', name: 'Baner, Pune' },
    { '@type': 'Place', name: 'Balewadi, Pune' },
  ],
  sameAs: [
    'https://youtube.com/@tsrcateringandevents?feature=shared',
    'https://www.instagram.com/tsrcateringandevents_premium',
    'https://www.facebook.com/share/18cox9K3R8/',
    'https://www.linkedin.com/in/pratik-tailor-3615a429',
  ],
};

const contactFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Which areas does TSR Catering serve?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'TSR Catering serves Baner, Pune and surrounding areas for weddings, corporate events, social gatherings and catering services.',
      },
    },
    {
      '@type': 'Question',
      name: 'What catering services does TSR Catering offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'TSR Catering offers wedding catering, buffet catering, corporate catering, social-event catering and canteen services.',
      },
    },
  ],
};

function JsonLd({ value }) {
  return <script type="application/ld+json">{JSON.stringify(value)}</script>;
}

function StructuredData({ includeContactFaq = false }) {
  return (
    <>
      <JsonLd value={businessSchema} />
      {includeContactFaq ? <JsonLd value={contactFaqSchema} /> : null}
    </>
  );
}

export default StructuredData;
